import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import React from 'react';
export default function EndPromotionConfirmationModal(props) {
  return /*#__PURE__*/React.createElement(ModalTransition, null, /*#__PURE__*/React.createElement(Modal, {
    heading: "End promotion",
    onClose: props.onCloseModal,
    appearance: "danger",
    actions: [{
      text: 'End promotion now',
      onClick: props.onPromotionEnd
    }, {
      text: 'Cancel',
      onClick: props.onCloseModal
    }]
  }, "This promotion will end immediately. It can\u2019t be reactivated."));
}